// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import buttonSizeVariants from "@flip/MobiusOverrides/Button/buttonSizeVariants";
import PaginationLeft from "@flip/XDL/Icons/PaginationLeft";
import PaginationRight from "@flip/XDL/Icons/PaginationRight";
import { xBaseTheme } from "@flip/XDL/types";
import { color, xScreen } from "@flip/XDL/Utilities";
import { mergeWithCss } from "@flip/XDL/Utilities/mergeWithCss";
import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            labelProps: {
                size: 14,
                lineHeight: "22px",
                weight: "normal",
                css: css`
                    padding: 0 8px 0 0;
                    width: auto;
                `,
            },
            cssOverrides: {
                formField: css`
                    width: auto;
                `,
                formInputWrapper: css`
                    width: 54px;
                `,
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: PaginationLeft,
            nextPage: PaginationRight,
            lastPage: "ChevronsRight",
        },
        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
            css: css`
                min-height: ${buttonSizeVariants["small"].height}px;
                border: none;
                &:hover:not(:disabled) {
                    background: ${color("common.ui8")};
                    border: none;
                    color: ${color("common.ui1")};
                }
            `,
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
                linkList: css`
                    margin-left: 50px;
                    ${xScreen("lte", 1112)} {
                        margin-left: 15px;
                    }

                    & > ul {
                        display: flex;
                        align-items: center;
                    }
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
